import {
    type FC
} from "react";
import type IHighlightButtonProps from "./type";
import {
    getHighlightButtonSolidColor,
    getHighlightButtonGlass,
    getHighlightButtonType
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../core/hooks";
import {
    ButtonMediaContext
} from "../button/context";
import Button from "../button";

/**
 * A generic button
 * @param props {@link IHighlightButtonProps}
 * @returns Element
 */
const HighlightButton: FC<IHighlightButtonProps> = ({
    glassEffect: glassEffectProp,
    isPlainBackground = false,
    android_disableSound,
    touchSoundDisabled,
    type = "neutral",
    customTheme,
    style,
    ...props
}) => {
    // Glass sits on media that does not follow the app theme, so its tint is always the light one.
    const {
        shapeConfigs,
        colors
    } = NCoreUIKitTheme.useContext({
        ...customTheme,
        themeKey: "light"
    });

    const {
        colors: themeColors
    } = NCoreUIKitTheme.useContext(customTheme);

    const glassEffect = glassEffectProp ?? shapeConfigs.glass.blur;

    const currentType = getHighlightButtonType({
        isPlainBackground,
        type
    });

    const isGlass = type === "glass" && !isPlainBackground;

    const glass = getHighlightButtonGlass({
        glass: shapeConfigs.glass,
        glassEffect,
        colors
    });

    const solidColor = getHighlightButtonSolidColor({
        colors: themeColors,
        type: currentType
    });

    return <ButtonMediaContext.Provider
        value={isGlass}
    >
        <Button
            {...props}
            customBorderColor={props.customBorderColor ?? (isGlass ? glass.borderColor : undefined)}
            customTextColor={props.customTextColor ?? (isGlass ? glass.titleColor : undefined)}
            customColor={props.customColor ?? (isGlass ? glass.color : solidColor)}
            android_disableSound={android_disableSound ?? touchSoundDisabled}
            customTheme={customTheme}
            style={isGlass ? [
                style,
                glass.style
            ] : style}
            type={currentType}
            variant="tonal"
        />
    </ButtonMediaContext.Provider>;
};
export default HighlightButton;
